import styled, { css } from "styled-components";
import { borderRadius, color, colorSchemeVariant, typeStyle, units, variant } from "@m/alchemy-theme";
export const ARROW_SIZE = 12;
export const Arrow = styled.div `
  [data-popper-placement^="top"] & {
    bottom: -${ARROW_SIZE / 2}px;
  }

  [data-popper-placement^="bottom"] & {
    top: -${ARROW_SIZE / 2}px;
  }

  [data-popper-placement^="left"] & {
    right: -${ARROW_SIZE / 2 - 2}px;
  }

  [data-popper-placement^="right"] & {
    left: -${ARROW_SIZE / 2 - 2}px;
  }
  &,
  &:before {
    position: absolute;
    width: ${ARROW_SIZE}px;
    height: ${ARROW_SIZE}px;
  }

  &:before {
    content: "";
    transition: transform 120ms ease-in-out;
    transform: rotate(45deg) scale(${(props) => (props.hasArrow ? 1 : 0)});
  }
`;
export const Background = styled.div `
  opacity: ${(props) => props.opacity};

  &:after {
    content: "";
  }

  &,
  &:after {
    border-radius: ${(props) => props.borderRadius || borderRadius("extraExtraLarge")};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${color("container")};

    @media (forced-colors) {
      outline: 1px solid ButtonBorder;
    }
  }

  &,
  ${Arrow}:before {
    background: ${color("container")};

    @media (forced-colors) {
      background: ButtonBorder;
    }
  }
`;
/** This has a min-width to prevent layout weirdness when arrows are present */
export const Content = styled.div `
  ${typeStyle("bodyS")};
  color: ${color("typeBody")};
  hyphens: auto;
  max-height: calc(100vh - 8px);
  overflow-wrap: break-word;
  overflow: ${({ overflow }) => overflow};
  overscroll-behavior: contain;
  padding: ${(props) => (props.hasPadding ? `${units(1.25)} ${units(2)}` : 0)};
  position: relative;
  line-height: 1.3;
  ${({ hasArrow }) => hasArrow && `min-width: 55px;`}
`;
export const Box = styled.div `
  /** TODO consider passing via style prop if possible to reduce dynamic css */
  --aui-PopperBox-color-border: ${({ accentPalette }) => color(/^(expressive|illustrative)/.test(accentPalette) ? "a11yBase" : "base", { palette: accentPalette })};

  position: relative;
  ${colorSchemeVariant({
    alchemyDark: `-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`
})}

  &,
  ${Background}:before, ${Background}:after, ${Content} {
    border-radius: ${(props) => props.borderRadius};
  }

  &,
  ${Arrow}:before {
    box-shadow:
      0 5px 10px 0 rgba(0, 0, 0, 0.25),
      0 10px 16px 0 rgba(0, 0, 0, 0.25);
  }

  ${variant("variant", {
    // using shadow instead of border to avoid padding issues
    default: css `
      ${Background} {
        box-shadow: none;
      }
    `,
    callout: css `
      ${Background}, ${Background}::after {
        box-shadow: inset 0 0 0 3px var(--aui-PopperBox-color-border);

        @media (forced-colors) {
          outline: 3px solid transparent;
          outline-offset: -3px;
        }
      }

      ${Arrow} {
        // prevent shadow from Background from being visible
        z-index: 1;

        @media (forced-colors) {
          // clip-path + transform causes a visual artefact in forced-colors mode, hide it by reverting z-index
          z-index: revert;
        }

        &::before {
          background-color: var(--aui-PopperBox-color-border);

          @media (forced-colors) {
            background-color: ButtonText;
          }

          // clip to only show visible half (triangle) of 45deg rotated square
          [data-popper-placement^="bottom"] & {
            clip-path: polygon(0 0, 100% 0, 0 100%);
            margin-top: 1px; // avoid 1px gap caused by rounding errors
          }
          [data-popper-placement^="top"] & {
            clip-path: polygon(100% 0, 100% 100%, 0 100%);
            margin-top: -1px; // avoid 1px gap caused by rounding errors
          }
          [data-popper-placement^="left"] & {
            clip-path: polygon(0 0, 100% 0, 100% 100%);
          }
          [data-popper-placement^="right"] & {
            clip-path: polygon(0 0, 100% 100%, 0 100%);
          }
        }
      }
    `
})}
`;
